import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=370f3efa&scoped=true&"
import script from "./DeleteIcon.vue?vue&type=script&lang=ts&"
export * from "./DeleteIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteIcon.vue?vue&type=style&index=0&id=370f3efa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f3efa",
  null
  
)

export default component.exports